import { mapGetters } from "vuex"

export default {
    data() {
        return {
            displayFormats: {
                day: "MMM D",
                week: "ll",
                month: "MMM YYYY",
                quarter: "[Q]Q - YYYY",
                year: "YYYY"
            },
            timeFormat: "DD/MM/YYYY",
            big: false,
            unit: "week"
        }
    },
    methods: {
        calculateUnit() {
            let days = 0
            if (this.range == "week") {
                days = this.numberOfPotentialResult * 7
            } else if (this.range == "day") {
                days = this.numberOfPotentialResult
            } else if (this.range == "month") {
                days = this.numberOfPotentialResult * 30
            }
            if (this.big) {
                days = days
            }
            if (days > 700) {
                return "quarter"
            } else if (days > 365) {
                return "month"
            } else if (days > 30) {
                if (this.range == "month") {
                    return "month"
                }
                return "week"
            }

            return this.range
        }
    },
    computed: {
        ...mapGetters({ darkMode: "user/darkMode" }),
        dateFormat() {
            if (this.range == "month") {
                return {
                    month: "short",
                    year: "numeric"
                }
            }
            if (this.range == "week") {
                return {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric"
                }
            }
        },
        numberOfPotentialResult() {
            let divied = 1
            if (this.range == "week") {
                divied = 7
            } else if (this.range == "month") {
                divied = 30
            }
            return (
                (this.dateRange.end.getTime() - this.dateRange.start.getTime()) /
                (1000 * 60 * 60 * 24) /
                divied
            )
        },
        optionsCatch() {
            return {
                legend: {
                    display: this.big
                },
                hover: {
                    mode: "nearest"
                },
                fill: false,
                responsive: true,
                maintainAspectRatio: false,
                elements: {
                    bar: {
                        borderWidth: 4
                    },
                    line: {
                        borderWidth: 3,
                        tension: 0.1
                    }
                },

                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            },
                            display: true,
                            stacked: true
                        }
                    ],
                    xAxes: [
                        {
                            bounds: "ticks",
                            stacked: true,
                            type: "time",
                            position: "bottom",
                            time: {
                                unit: this.unit,
                                tooltipFormat: this.timeFormat,
                                displayFormats: this.displayFormats
                            },
                            scaleLabel: {
                                display: false
                            }
                        }
                    ]
                }
            }
        },
        optionsAvg() {
            return {
                legend: {
                    labels: {
                        fontColor: this.darkMode ? "#fff" : "#666"
                    },
                    display: this.big
                },
                responsive: true,
                maintainAspectRatio: false,
                elements: {
                    bar: {
                        borderWidth: 4
                    },
                    line: {
                        borderWidth: 3,
                        tension: 0.3
                    },
                    point: {
                        radius: 4
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem) {
                            return tooltipItem.yLabel + "%"
                        }
                    }
                },
                scales: {
                    yAxes: [
                        {
                            scaleLabel: {
                                display: false
                            },
                            ticks: {
                                max: 100,
                                beginAtZero: true,
                                callback: function(value, index, values) {
                                    return value + "%"
                                }
                            }
                        }
                    ],
                    xAxes: [
                        {
                            type: "time",
                            time: {
                                unit: this.unit,
                                timeFormat: this.timeFormat,
                                tooltipFormat: this.timeFormat,
                                displayFormats: this.displayFormats
                            },
                            scaleLabel: {
                                display: true
                            }
                        }
                    ]
                }
            }
        },

        optionsAvgCelcius() {
            return {
                legend: {
                    labels: {
                        fontColor: this.darkMode ? "#fff" : "#666"
                    },
                    display: this.big
                },
                responsive: true,
                maintainAspectRatio: false,
                elements: {
                    bar: {
                        borderWidth: 4
                    },
                    line: {
                        borderWidth: 3,
                        tension: 0.3
                    },
                    point: {
                        radius: 4
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem) {
                            return tooltipItem.yLabel + "°C"
                        }
                    }
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                callback: function(value, index, values) {
                                    return value + "°C"
                                }
                            },
                            scaleLabel: {
                                display: false
                            }
                        }
                    ],
                    xAxes: [
                        {
                            type: "time",
                            time: {
                                unit: this.unit,
                                timeFormat: this.timeFormat,
                                tooltipFormat: this.timeFormat,
                                displayFormats: this.displayFormats
                            },
                            scaleLabel: {
                                display: true
                            }
                        }
                    ]
                }
            }
        }
    }
}
